import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[swiperContent]',
    standalone: false
})
export class SwiperContentDirective {

  constructor(public template: TemplateRef<any>) { }

}
